const API = "https://api.themoviedb.org/3";

export function get(path) {
    const separator = path.includes("?") ? "&" : "?";
    return fetch(API + path + separator + "api_key=50dadd4cc349d67261295f7d03041022&language=es-ES", {
        headers: {
            "Content-Type": 'application/json;charset=utf-8',
        },
    }).then((result) => result.json());
}